<template>
    <div class="w-full mb-3">
        <Button label="Добавить карту" icon="pi pi-plus" @click="showDialog" size="small" class="" :disabled="loading" />
    </div>
    <Dialog v-if="(isUserInGroup('admin') || isUserInGroup('manager'))" header="Добавить карту" class="flex flex-column" modal
        v-model:visible="displayDialog" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '60vw'}" >

        <div v-if="merchant_id" class="w-full flex flex-column">
            <div class="w-full flex flex-column mb-3">
                <span class="flex text-600 mb-2 text-sm">
                    Статус:
                </span>
                <SelectButton v-model="active" :options="active_list" optionLabel="name" optionValue="value" aria-labelledby="basic" />
            </div> 

            <div class="flex flex-row w-full mb-3">
                <div class="flex flex-column w-full">
                    <span class="flex mr-2 mb-1">Банк: </span>
                    <Dropdown v-model="cardBank" :options="bankCodes" filter placeholder="Банк" class="flex" option-label="label" >

                        <template #value="slotProps">
                            <div v-if="slotProps.value" class="flex align-items-center">
                                <img :src="getBankImage(slotProps.value.val)" class="mr-2" style="width: 18px" />
                                <div>{{ slotProps.value.label }}</div>
                            </div>
                            <span v-else>
                                {{ slotProps.placeholder }}
                            </span>
                        </template>
                        
                        <template #option="slotProps">
                            <div class="flex align-items-center">
                                <img :src="getBankImage(slotProps.option.val)" class="mr-2" style="width: 18px" />
                                <div>{{ slotProps.option.label }}</div>
                            </div>
                        </template>
                    </Dropdown>
                </div>
            </div>

            <RecipientFields @check_valid="checkFields" @return_fields="setFields"
                :fields="cardFields"
                :requiredFields="cardFields" 
                :currency="cardFieldsCur" />

            <div class="w-full mb-3 flex justify-content-between flex-wrap">
                <Button label="Добавить" @click='add()' :disabled="!fieldsValid || loading" class="flex"/>
                <Button label="Закрыть" icon="pi pi-check" @click="closeDialog" outlined class="flex" autofocus severity="secondary" :disabled="loading"/>
            </div>
        </div>
        <div v-else class="w-full flex flex-column">
            <span class="flex text-600 mb-2 text-sm">
                Необходимо выбрать мерчанта
            </span>
        </div>
       
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/Connect';  
import Helper from '@/assets/js/Helper'
import RecipientFields from '@/components/widgets/RecipientFields.vue'
import { BankList } from '@/assets/js/classes/PaymentSystem.js'
import { CurrencyList} from '@/assets/js/classes/Currency.js'

export default {
    props: ['merchant_id'],
    data() {
        return {
            displayDialog: false,
            loading: false,
            active: false,
            bankCodes: [],
            banks: [],
            cardBank: null,
            active_list: [
                {name: 'Активна', value: true},
                {name: 'Не активна', value: false}
            ],
            fields: ['fullname', 'phone_number', 'card_number', 'account_number', 'wallet_address', 'wallet_network', 'telegram', 'bank_name', 'address', 'city', 'country', 'swift_code', 'iban_number', 'upi_id'],
            cardFields: [],
            fieldsValid: false,
            cardFieldsCur: null,
            cardDataFields: {},
        }
    },
    components: {
        RecipientFields
    },
    watch: {
        cardBank: function (bank) {
            this.cardFields = this.getFieldsByBank(bank.val)
            this.cardFieldsCur = this.getCurrencyByBank(bank.val)
        }
    },
    methods: {
        getBankTitle(code){
            let bankObj = new BankList()
            bankObj.items = this.banks
            const bankCode = bankObj.GetTitle(code, this.lang_)
            return (bankCode) ? bankCode : code
        },
        getBankImage(code){
            let bankObj = new BankList()
            bankObj.items = this.banks
            const bankCode = bankObj.GetImage(code)
            return (bankCode) ? bankCode : code
        },
        getFieldsByBank(bankCode){
            let bank = null
            let bankObj = new BankList()
            bankObj.items = this.banks
            for(const key in this.banks){
                if(this.banks[key].code === bankCode){
                    bank = this.banks[key]
                    break
                }
            }
            if(bank && bank.recipient_fields){
                return bank.recipient_fields
            }
            return []
        },
        getCurrencyByBank(bankCode){
            const bank = this.banks[bankCode]
            if(bank){
                return bank.currency_code
            }
            return null
        },
        checkFields(fields){
            this.fieldsValid = fields
        },
        setFields(fields){
            this.cardDataFields = fields
        },
        showDialog(){
            this.displayDialog = true
        },
        closeDialog(){
            this.displayDialog = false
        },
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        async GetBanks(){
            this.banks = await BankList.GetList(this.$store).then(r=>r)
            if(this.banks){
                this.bankCodes = Object.keys(this.banks).map(key => {
                    return {
                        label: (this.banks[key].titles) ? this.banks[key].titles['ru'] : this.banks[key].code,
                        val: this.banks[key].code
                    }
                })
            }
        },
        async GetCurrencies(){
            this.currencies = await CurrencyList.GetList(this.$store).then(r=>r)
        },
        async add(){
            this.loading = true
            const data = {
                merchant_id: this.merchant_id,
                active: this.active,
                bank_code: this.cardBank.val,
                fields: this.cardDataFields
            }
            const add = await this.connect.add_card(data).then(res=>res)
            if(add.result && add.data){
                this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Карта добавлена', life: 2000 })
                this.$emit('update')
                this.closeDialog()
                this.loading = false
            } else {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка добавления карты', life: 2000 })
                this.loading = false
            }
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted(){
        this.GetBanks()
        this.GetCurrencies()
    }
}
</script>